<template>
  <div class="size-slider-container">
    <!-- Карточки размеров - отображаем только те, где наличие > 0 -->
    <div
      v-for="(sizeItem, index) in sortedAvailableSizes"
      :key="index"
      :class="['product-size-card', { selected: selectedIndex === index }]"
      @click="selectSize(index)"
    >
      {{ sizeItem.size }}
    </div>
  </div>

  <!-- Лента "На возврате" (не кликабельная) -->
  <div class="on-return-slider" v-if="!isFromAbroad && sortedReturnSizes.length > 0">
    <div class="on-return-label">На возврате</div>
    <div class="on-return-ribbon">
      <div
        v-for="sizeItem in sortedReturnSizes"
        :key="'return-' + sizeItem.size"
        class="product-size-card on-return-card"
      >
        {{ sizeItem.size }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedIndex: null,
    };
  },
  props: {
    productSizes: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    dropPrice: {
      type: Number,
      default: 0,
      required: true
    },
    retailPrice: {
      type: Number,
      default: 0,
      required: true
    },
    productName: {
      type: String,
      required: true,
    },
    productPhoto: {
      type: String,
      required: true,
    },
    isDropProduct: {
      type: Boolean,
      required: true
    },
    isFromAbroad: {
      type: Boolean,
      required: true
    },
    batchId: {
      type: [Number, String],
      default: null,
    },
    onReturn: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // Получаем доступные размеры (количество > 0)
    availableSizes() {
      const sizes = [];
      for (const [size, quantity] of Object.entries(this.productSizes)) {
        if (quantity > 0) {
          sizes.push({ size, quantity });
        }
      }
      return sizes;
    },
    
    // Размеры на возврате (количество > 0), в том же порядке, что и в основной ленте
    sortedReturnSizes() {
      return Object.entries(this.onReturn || {})
        .filter(([, quantity]) => quantity > 0)
        .map(([size, quantity]) => ({ size, quantity }))
        .sort((a, b) => this.compareSizes(a.size, b.size));
    },

    // Сортируем доступные размеры (без side-effects)
    sortedAvailableSizes() {
      // Создаем копию для сортировки
      const sizesToSort = [...this.availableSizes];
      
      // Сортируем размеры
      return sizesToSort.sort((a, b) => {
        return this.compareSizes(a.size, b.size);
      });
    }
  },
  mounted() {
    if (window.Telegram?.WebApp) {
      this.MiniApp = window.Telegram.WebApp;
      this.MiniApp.ready();

      this._mainButtonHandler = this.handleMainButtonClick.bind(this);
      this.MiniApp.MainButton.onClick(this._mainButtonHandler);
    }    
  },

  beforeUnmount() {
    if (this.MiniApp && this._mainButtonHandler) {
      this.MiniApp.MainButton.offClick(this._mainButtonHandler);
    }
  },
  methods: {
    // Универсальная функция сравнения размеров
    compareSizes(sizeA, sizeB) {
      // Приводим к нижнему регистру для сравнения
      const a = sizeA.toLowerCase().trim();
      const b = sizeB.toLowerCase().trim();
      
      // Порядок буквенных размеров (обновленный)
      const sizeOrder = [
        'xs', 's', 'm', 'l', 'xl', 
        '2xl', 'xxl', 
        '3xl', 'xxxl', 
        '4xl', 'xxxxl'
      ];
      
      // Нормализуем размеры для сравнения (убираем возможные вариации)
      const normalizedA = this.normalizeSize(a);
      const normalizedB = this.normalizeSize(b);
      
      // Проверяем, являются ли размеры буквенными
      const aIndex = sizeOrder.indexOf(normalizedA);
      const bIndex = sizeOrder.indexOf(normalizedB);
      
      // Если оба размера буквенные
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      
      // Если один буквенный, а другой числовой - числовые идут первыми
      if (aIndex !== -1 && bIndex === -1) return 1;
      if (aIndex === -1 && bIndex !== -1) return -1;
      
      // Обрабатываем числовые размеры и диапазоны
      const aNum = this.extractNumber(a);
      const bNum = this.extractNumber(b);
      
      // Если оба числовые
      if (aNum !== null && bNum !== null) {
        return aNum - bNum;
      }
      
      // Если один числовой, а другой нет
      if (aNum !== null && bNum === null) return -1;
      if (aNum === null && bNum !== null) return 1;
      
      // Для всех остальных случаев используем строковое сравнение
      return a.localeCompare(b);
    },
    
    // Нормализует размер для сравнения (приводит к стандартному формату)
    normalizeSize(size) {
      const normalized = size
        .toLowerCase()
        .replace(/\s+/g, '') // убираем пробелы
        .replace(/^(\d)x(l)$/, '$1xl') // преобразуем 2xl в 2xl
        .replace(/^xxl$/, '2xl') // преобразуем xxl в 2xl
        .replace(/^xxxl$/, '3xl') // преобразуем xxxl в 3xl
        .replace(/^xxxxl$/, '4xl'); // преобразуем xxxxl в 4xl
      
      return normalized;
    },
    
    // Извлекает число из строки (работает с одиночными числами и диапазонами)
    extractNumber(size) {
      // Ищем числа в строке (включая дробные)
      const numbers = size.match(/\d+(\.\d+)?/g);
      if (!numbers || numbers.length === 0) return null;
      
      // Для диапазонов берем первое число (например, "35-38" → 35)
      return parseFloat(numbers[0]);
    },
    
    selectSize(index) {
      this.selectedIndex = index;
      const selectedSize = this.sortedAvailableSizes[index].size;
      console.log('Выбран размер:', selectedSize);

      // Показываем кнопку сразу после выбора размера
      if (this.MiniApp) {
        this.MiniApp.MainButton.setParams({
          color: '#32cd32',
          text: 'Перейти к оформлению',
        });
        this.MiniApp.MainButton.show();
      }
    },

    handleMainButtonClick() {
      console.log("MainButton clicked");
      const isDrop = localStorage.getItem('is_drop') === 'true';
      console.log("isDrop:", isDrop);

      if (this.selectedIndex === null) {
        console.error("Размер не выбран");
        return;
      }

      this.MiniApp.MainButton.hide();
      console.log("MainButton hidden");

      const selectedSize = this.sortedAvailableSizes[this.selectedIndex].size;

      if (isDrop && this.isDropProduct && !this.isFromAbroad) {
          console.log("Navigating to DropOrder route with params:", {
              dropPrice: this.dropPrice,
              retailPrice: this.retailPrice,
              selectedSize: selectedSize,
              productName: this.productName,
              productPhoto: this.productPhoto,
          });

          this.$router.push({
              name: 'DropOrder',
              params: {
                  dropPrice: this.dropPrice,
                  retailPrice: this.retailPrice,
                  selectedSize: selectedSize,
                  productName: this.productName,
                  productPhoto: this.productPhoto,
                  batchId: this.batchId,
              }
          });

      // Блок else if для товара из-за границы
      } else if (isDrop && this.isDropProduct && this.isFromAbroad) {
          console.log("Navigating to AbroadOrder route with params:", {
              retailPrice: this.retailPrice,
              selectedSize: selectedSize,
              productName: this.productName,
              productPhoto: this.productPhoto,
              isFromAbroad: this.isFromAbroad
          });

          this.$router.push({
              name: 'Payment',
              query: {
                  paymentAmount: this.dropPrice,
                  selectedSize: selectedSize,
                  productName: this.productName,
                  productPhoto: this.productPhoto,
                  isDrop: true, // для товаров из-за границы используем обычную оплату
                  isFromAbroad: true, // указываем, что товар из-за границы
                  batchId: this.batchId,
              }
          });
      } else {
          console.log("Navigating to Payment route with params:", {
              paymentAmount: this.retailPrice,
              selectedSize: selectedSize,
              productName: this.productName,
              productPhoto: this.productPhoto,
              isFromAbroad: this.isFromAbroad
          });

          this.$router.push({
            name: 'Payment',
            query: {
              paymentAmount: this.retailPrice,
              selectedSize: selectedSize,
              productName: this.productName,
              productPhoto: this.productPhoto,
              isDrop: false,
              batchId: this.batchId,
            }
          });
      }
    }
  }
};
</script>

<style scoped>
.size-slider-container {
  width: 100%;
  display: flex;
  font-family: 'Inter', sans-serif;
  overflow: auto;
  margin-bottom: 8vw;
  gap: 2vw;
  align-items: center;
  text-transform: uppercase;
  padding: 0 4vw;
  position: absolute;
  top: 132vw;
  backdrop-filter: blur(2px);
}

/* Скрываем скроллбар */
.size-slider-container {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
}

.size-slider-container::-webkit-scrollbar { /* Chrome, Safari, Opera */
  display: none;
}

.product-size-card {
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  min-width: 12vw;
  max-width: 22vw;
  height: 12vw;
  background-color: rgba(0, 0, 0, 0.4);
  font-size: 20px;
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: border-color 0.3s, background-color 0.3s;
  flex: 0 0 auto;
}

.product-size-card:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.selected {
  border-color: #0BDA51;
  background-color: rgba(255, 255, 255, 0.3);
}

/* Лента "На возврате" */
.on-return-slider {
  width: 100%;
  position: absolute;
  top: 146vw;
  padding: 0 4vw;
  font-family: 'Inter', sans-serif;
}

.on-return-label {
  color: #F2912E;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 1.5vw;
}

.on-return-ribbon {
  display: flex;
  gap: 2vw;
  overflow: auto;
  text-transform: uppercase;
  scrollbar-width: none;
  -ms-overflow-style: none;
  backdrop-filter: blur(2px);
}

.on-return-ribbon::-webkit-scrollbar {
  display: none;
}

.on-return-card {
  border-color: #F2912E;
  cursor: default;
}

.on-return-card:hover {
  background-color: rgba(0, 0, 0, 0.4);
}
</style>